export default __webpack_public_path__ + "static/media/office-js.23216b65.jpeg";